module.exports = __webpack_public_path__ + "static/media/bn_3.3304922a.png";